import api from "@/lib/axios";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

const getListPesertaPasca = async (
  page: string | undefined,
  limit: string | undefined,
  search: string | undefined,
  status: string | undefined,
) => {
  const params = new URLSearchParams();

  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (status) params.append("status", status);

  const response = await api.get(
    `/verifikator-pasca/peserta/index?${params.toString()}`,
  );
  return response.data?.data;
};

export default function VerifikatorPascaPenilaianPage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const limitParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const statusParams = searchParams.get("status");

  const { data, isPending } = useQuery({
    queryKey: [
      "listPesertaVerifikasi",
      pageParams,
      limitParams,
      searchQueryParams,
      statusParams,
    ],
    queryFn: () =>
      getListPesertaPasca(
        pageParams as string,
        limitParams as string,
        searchQueryParams as string,
        statusParams as string,
      ),
  });

  return (
    <div>
      <DataTable
        data={data?.data || []}
        columns={columns}
        paginationData={data}
        isPending={isPending}
      />
    </div>
  );
}
